import { render, staticRenderFns } from "./Churches.vue?vue&type=template&id=656e4678&"
import script from "./Churches.vue?vue&type=script&lang=js&"
export * from "./Churches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports